import React, {useState} from "react";
import PropTypes from "prop-types";
import {BeatLoader} from "react-spinners";

// @mui/material components
import {Tooltip} from "@mui/material";

// @mui/icons-material
import {InfoOutlined} from "@mui/icons-material";

// style
import {black500, blueColor, green500, greyishBlue100, greyishBlue500, red500} from "assets/jss/main";

InfoValueCard.propTypes = {
    label: PropTypes.node,
    value: PropTypes.node,
    labelColor: PropTypes.oneOf([
        'success',
        'warning',
        'error',
        'info',
        'grey'
    ]),
    borderColor: PropTypes.oneOf([
        'success',
        'warning',
        'error',
        'info',
        'grey'
    ]),
    icon: PropTypes.node,
    subtext: PropTypes.node,
    loading: PropTypes.bool,
    tooltip: PropTypes.string,
    tooltipTitle: PropTypes.string,
};

const theme = {
    success: {
        color: green500,
    },
    warning: {
        color: '#f59f0a'
    },
    error: {
        color: red500
    },
    info: {
        color: blueColor
    },
    none: {
        color: greyishBlue100
    },
    grey: {
        color: greyishBlue500
    }
}

function InfoValueCard({
   label,
   value,
   labelColor,
   borderColor,
   icon,
   subtext = null,
   loading = false,
   tooltip,
   tooltipTitle
}) {
    const [hovered, setHovered] = useState(false);
    const colorKey = labelColor || borderColor || 'none';
    const themeColor = theme[colorKey]?.color ?? greyishBlue100;

    return (
        <div
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
            style={{
                position: "relative",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "16px",
                borderRadius: "8px",
                border: `1px solid ${hovered ? greyishBlue500 : greyishBlue100}`,
                backgroundColor: "#ffffff",
                boxShadow: "0 1px 4px rgba(0,0,0,0.04)",
                transition: "border-color 0.2s ease",
                maxWidth: "520px",
                width: "100%",
                cursor: "default",
            }}
        >
            <div style={{display: "flex", flexDirection: "column", alignSelf: 'flex-start'}}>
                <span
                    style={{
                        fontSize: "16px",
                        fontWeight: "700",
                        color: themeColor,
                        textTransform: "uppercase",
                        letterSpacing: '0.6px'
                    }}
                >
                  {label}
                </span>
                <div style={{display: 'flex', flexDirection: 'column', marginTop: '20px'}}>
                    <span
                       style={{
                           fontSize: "32px",
                           fontWeight: "700",
                           color: black500,
                       }}
                   >
                       {loading ? <BeatLoader size={8} color="#4f46e5"/> : value}
                   </span>
                    {loading ? null : (
                        <span
                            style={{
                                marginTop: '8px',
                                fontSize: "16px",
                                fontWeight: "700",
                                color: greyishBlue500,
                            }}
                        >
                            {subtext}
                        </span>
                    )}
                </div>
            </div>
            <div style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-end",
                alignSelf: "stretch",
                justifyContent: "space-between"
            }}>
                {tooltip && (
                    <Tooltip
                        title={
                            <div>
                                {tooltipTitle && <div style={{fontWeight: 600, marginBottom: 4}}>{tooltipTitle}</div>}
                                <div>{tooltip}</div>
                            </div>
                        }
                        arrow
                        placement="top"
                    >
                        <InfoOutlined style={{fontSize: 20, color: "#9ca3af", cursor: "pointer"}}/>
                    </Tooltip>
                )}
                {icon && (
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexShrink: 0,
                        }}
                    >
                        {icon}
                    </div>
                )}
            </div>
        </div>
    );
}

export default InfoValueCard;
